import { LayoutHOC } from 'base/ui/layout/layout';

import { znsRoutes } from './routes';
import createListZNS from './ListZNS/ListZNSPage';
import createReportZNS from './ReportZNS/ReportZNS';
import { createZaloTaskZNSPage } from './ZaloTaskZNS/create';
import createDetailZNSTemplate from './DetailZNSTemplate/Detail';
import createConnectZalo from './ConnectZNS';

export const createZNSPage = (layoutHOC: LayoutHOC) => {
  const ListZNS = createListZNS();
  const ReportZNS = createReportZNS();
  const ZaloTask = createZaloTaskZNSPage();
  const ConnectZalo = createConnectZalo();
  const DetailZNSTemplate = createDetailZNSTemplate();

  const ZNSPage = layoutHOC(znsRoutes);
  return () => (
    <ZNSPage
      ListZNS={ListZNS}
      ReportZNS={ReportZNS}
      ZaloTask={ZaloTask}
      ConnectZalo={ConnectZalo}
      DetailZNSTemplate={DetailZNSTemplate}
    />
  );
};
